import {getSearchURL} from '@malt/nuxt-search-module/runtime/composables/useSearchHelpers';
import type {LocationItem} from '../search.types';

type GetSearchURLParams = {
    baseURLLink: string;
    query: string;
    location: LocationItem | null;
    sourceComponent?: string; // to track the search_started Amplitude event
};

export function redirectToSearch({baseURLLink, location, query, sourceComponent}: GetSearchURLParams) {
    if (typeof baseURLLink !== 'string' || !baseURLLink) {
        return window.location.href;
    }

    return getSearchURL({
        baseURLLink,
        query,
        location: location as any,
        sourceComponent,
    });
}
